import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from 'react-bootstrap/lib/Alert';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormGroup from '../inputs/fg-input.js';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage } from 'react-intl';
import TranslationService from '../../services/translation-service.js';
import TranslationStore from '../../store/translation-store.js';
import { Table } from 'react-bootstrap';
import BulkImport from './teacher-bulk-import.js';
import Select from 'react-select';

export default class InsertTranslation extends React.Component {

    constructor(props) {
        super();
        this.state = {
            languages: [], submitTrans: props.onSubmit || function () { }, languageSelect:props.languages || undefined

        };
    }
/* 
    componentDidMount() {
        TranslationService.getAllLanguages();
    }

    componentWillMount() {
        TranslationStore.on("CHANGE", () => {
            // var languages = this.sort(TranslationStore.languages);
            var languages = TranslationStore.languages;
            if (languages != undefined && languages.length > 0) {
                this.setState({ languages: languages });
            }
        });
    } */

    sort(languages) {
        if (languages == undefined) return [];
        var priority = ["English", "US English", "German", "Dutch", "Swedish", "Latin American Spanish", "French"];



        var sortedLanguages = [];
        for (var i = 0; i < languages.length; i++) {
            if (languages[i].ietf == 'en') {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "US English") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "German") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Dutch") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Swedish") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Latin American Spanish") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "French") {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text != "All"){
                sortedLanguages.push(languages[i]);
            }
        }

        return sortedLanguages;
    }

    submit() {

        var newTranslations = [];
        for (var i = 0; i < this.languages.length; i++) {
            if (this.languages[i].trans != "" && this.languages[i].trans != undefined) {
                newTranslations.push({ ietf: this.languages[i].ietf, trans: this.languages[i].trans })
            }
        }

        TranslationService.addNewTranslations(newTranslations)
        this.state.submitTrans();
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({
            submit: nextProps.submit || function () { }, languageSelect:nextProps.languages|| undefined
        })
    }

    render() {


        let submitButton = React.createElement(Button, {
            onClick: this.submit.bind(this),
            bsStyle: 'primary',
            className: "btn-block"
        }, "Submit");

        return (
            <div>
                <Row>
                    <Col sm={8}>{"Add New Translation"}</Col>
                </Row>
                <p></p>
                <Row>
                    <Col sm={8}>{submitButton}</Col>
                </Row>
                <p></p>
                <Table condensed striped responsive bordered>
                    <tbody>
                        {this.renderRows()}
                    </tbody>
                </Table>
            </div>
        )

    }

    getFunction(idx, e) {
        this.languages[idx].trans = e.target.value;
        this.setState({});
    }

    renderRows() {

        var items = [];
        if (this.state.languageSelect != undefined ){
            this.languages = this.state.languageSelect.state.languages;
        } else {
            return;
        }

        for (var idx = 0; idx < this.languages.length; idx++) {
            if (this.languages[idx].trans == undefined) {
                this.languages[idx].trans = "";
            }
            items.push(<tr className={"animate-color p-0"}>
                {this.languages[idx].text}
                <td>
                    <FormGroup controlId="formBasicText" >
                        <FormControl value={this.languages[idx].trans} type="text" onChange={this.getFunction.bind(this, idx)} />
                    </FormGroup>
                </td>
            </tr>)
        }
        return items
    }
};


// WEBPACK FOOTER //
// ./src/components/forms/insert-translation-form.js